<template>
    <div class="viewbox">
        <div v-if="data">
            <div class="posleft">
                memberID: {{data.memberID}}  [{{showGruppe()}}]
            </div>
            <div class="posright h2em">
                <MemberPanelSwitch v-model="panelstate" @createpdf="PdfInvoice"></MemberPanelSwitch>
            </div>
            <div class="clear"></div>
            <div v-if="data.memberProperties">
                <div>
                    <div>{{data.memberProperties.company}}</div>
                    <div>{{data.anzeigename}}</div>
                    <div>
                        <div class="left">[{{data.memberEmail}}]</div>
                        <div v-if="RMEdit">
                            <div class="left p1"><input type="text" v-model="data.memberProperties.rechnungseMail" placeholder="Rechnungs@eMail" /></div>
                            <div class="left p1 actionHand" @click="ChangeRechnungMail(data)"><v-icon name="save" scale="1.2"></v-icon></div>
                        </div>
                        <div v-if="!RMEdit">
                            <div class="left p1">{{View(data.memberProperties.rechnungseMail)}}</div>
                            <div class="left p1 actionHand" @click="RMEdit=true"><v-icon name="edit" scale="1.2"></v-icon></div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>

                <div v-if="isExpand('upd')" class="bankblock">
                    <v-icon name="fingerprint" scale="1.2"></v-icon>
                    {{data.aKey}}
                </div>

                <div v-if="isExpand('add')" class="adressblock">
                    <v-icon name="address-card" scale="1.2"></v-icon>
                    {{data.memberProperties.address}}
                    {{data.memberProperties.plz}}
                    {{data.memberProperties.city}}

                </div>
                <div v-if="isExpand('ban')" class="bankblock">
                    <v-icon name="credit-card" scale="1.2"></v-icon>
                    {{data.memberProperties.accountowner}}
                    {{data.memberProperties.bankname}}
                    {{data.memberProperties.iban}}
                    {{data.memberProperties.gpn}}

                </div>
                <div v-if="isExpand('kau')" class="bankblock">
                    <v-icon name="shopping-cart" scale="1.2"></v-icon>
                    <MemberPanelKaufe :fireid="kaufid">
                    </MemberPanelKaufe>
                </div>

                <div v-if="isExpand('inv')" class="bankblock">
                    <v-icon name="file-pdf" scale="1.2"></v-icon>
                    <MemberPanelInvoice :memberid="data.memberID"></MemberPanelInvoice>
                </div>
                <div v-if="isExpand('raw')" class="bankblock">
                    <v-icon name="sitemap" scale="1.2"></v-icon>
                    <MemberPanelProduktEdit :memberID="data.memberID" @refresh="reload"></MemberPanelProduktEdit>

                </div>
                <div v-if="isExpand('drv')" class="bankblock">
                    <v-icon name="cloud" scale="1.2"></v-icon>
                    <MemberPanelDrive :memberID="data.memberID" @refresh="reload"></MemberPanelDrive>
                </div>

            </div>
        </div>
        <div v-else>
            kein Ergebnis vorhanden
        </div>
    </div>
</template>

<script>

    import MemberPanelSwitch from '@/components/memberPanelSwitch.vue'
    import MemberPanelKaufe from '@/components/memberPanelKaufe.vue'
    import MemberPanelInvoice from '@/components/invoicelist.vue'
    import MemberPanelProduktEdit from '@/components/produktEditPanel.vue'
    import MemberPanelDrive from '@/components/drivepanel.vue'

    import { getProforma, PushRechnungseMail} from '@/moduls/auth.js'

    export default {


        name: 'KundenAnzeige',
        props: {
            data: Object,
        },
        components: {
            //Kundenliste,
            MemberPanelSwitch,
            MemberPanelKaufe,
            MemberPanelInvoice,
            MemberPanelProduktEdit,
            MemberPanelDrive
        },
        data() {
            return {
                rawview: false,
                working: false,
                panelstate: [
                    { topic: 'add', expand: false },
                    { topic: 'ban', expand: false },
                    { topic: 'kau', expand: false },
                    { topic: 'upd', expand: false },
                    { topic: 'raw', expand: false },
                    { topic: 'inv', expand: false },
                    { topic: 'drv', expand: false }
                ],
                kaufid: '',
                RMEdit: false,
            }
        },
        methods: {
            isExpand(panel) {
                for (var i = 0; i < this.panelstate.length; i++) {
                    if (panel == this.panelstate[i].topic) {
                        if (this.panelstate[i].expand && panel == 'kau') {

                            this.kaufid = this.data.memberID
                            console.log('kauf' + this.kaufid)
                        }
                        return this.panelstate[i].expand
                    }
                }
                return false
            },
            initState() {
                this.panelstate = [
                    { topic: 'add', expand: false },
                    { topic: 'ban', expand: false },
                    { topic: 'kau', expand: false },
                    { topic: 'upd', expand: false },
                    { topic: 'raw', expand: false },
                    { topic: 'inv', expand: false },
                    { topic: 'drv', expand: false }
                ]
            },
            reload(memberID) {
                console.log('refresh ' + memberID)
                this.$emit('refresh',memberID)
            },
            async PdfInvoice() {
                if (this.data) {
                    let memberID = this.data.memberID
                    console.log("PDFI "+ memberID)
                    if (memberID) {
                        let pdfWindow = window.open('rechnung')
                        let loade = 'data:image/gif;base64,R0lGODlhIAAgAPMAAP///wBYksbZ5oSuyrbO35q80zZ7qFaQttjl7eTt8rzS4R5rngRakwAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAIAAgAAAE5xDISWlhperN52JLhSSdRgwVo1ICQZRUsiwHpTJT4iowNS8vyW2icCF6k8HMMBkCEDskxTBDAZwuAkkqIfxIQyhBQBFvAQSDITM5VDW6XNE4KagNh6Bgwe60smQUB3d4Rz1ZBApnFASDd0hihh12BkE9kjAJVlycXIg7CQIFA6SlnJ87paqbSKiKoqusnbMdmDC2tXQlkUhziYtyWTxIfy6BE8WJt5YJvpJivxNaGmLHT0VnOgSYf0dZXS7APdpB309RnHOG5gDqXGLDaC457D1zZ/V/nmOM82XiHRLYKhKP1oZmADdEAAAh+QQJCgAAACwAAAAAIAAgAAAE6hDISWlZpOrNp1lGNRSdRpDUolIGw5RUYhhHukqFu8DsrEyqnWThGvAmhVlteBvojpTDDBUEIFwMFBRAmBkSgOrBFZogCASwBDEY/CZSg7GSE0gSCjQBMVG023xWBhklAnoEdhQEfyNqMIcKjhRsjEdnezB+A4k8gTwJhFuiW4dokXiloUepBAp5qaKpp6+Ho7aWW54wl7obvEe0kRuoplCGepwSx2jJvqHEmGt6whJpGpfJCHmOoNHKaHx61WiSR92E4lbFoq+B6QDtuetcaBPnW6+O7wDHpIiK9SaVK5GgV543tzjgGcghAgAh+QQJCgAAACwAAAAAIAAgAAAE7hDISSkxpOrN5zFHNWRdhSiVoVLHspRUMoyUakyEe8PTPCATW9A14E0UvuAKMNAZKYUZCiBMuBakSQKG8G2FzUWox2AUtAQFcBKlVQoLgQReZhQlCIJesQXI5B0CBnUMOxMCenoCfTCEWBsJColTMANldx15BGs8B5wlCZ9Po6OJkwmRpnqkqnuSrayqfKmqpLajoiW5HJq7FL1Gr2mMMcKUMIiJgIemy7xZtJsTmsM4xHiKv5KMCXqfyUCJEonXPN2rAOIAmsfB3uPoAK++G+w48edZPK+M6hLJpQg484enXIdQFSS1u6UhksENEQAAIfkECQoAAAAsAAAAACAAIAAABOcQyEmpGKLqzWcZRVUQnZYg1aBSh2GUVEIQ2aQOE+G+cD4ntpWkZQj1JIiZIogDFFyHI0UxQwFugMSOFIPJftfVAEoZLBbcLEFhlQiqGp1Vd140AUklUN3eCA51C1EWMzMCezCBBmkxVIVHBWd3HHl9JQOIJSdSnJ0TDKChCwUJjoWMPaGqDKannasMo6WnM562R5YluZRwur0wpgqZE7NKUm+FNRPIhjBJxKZteWuIBMN4zRMIVIhffcgojwCF117i4nlLnY5ztRLsnOk+aV+oJY7V7m76PdkS4trKcdg0Zc0tTcKkRAAAIfkECQoAAAAsAAAAACAAIAAABO4QyEkpKqjqzScpRaVkXZWQEximw1BSCUEIlDohrft6cpKCk5xid5MNJTaAIkekKGQkWyKHkvhKsR7ARmitkAYDYRIbUQRQjWBwJRzChi9CRlBcY1UN4g0/VNB0AlcvcAYHRyZPdEQFYV8ccwR5HWxEJ02YmRMLnJ1xCYp0Y5idpQuhopmmC2KgojKasUQDk5BNAwwMOh2RtRq5uQuPZKGIJQIGwAwGf6I0JXMpC8C7kXWDBINFMxS4DKMAWVWAGYsAdNqW5uaRxkSKJOZKaU3tPOBZ4DuK2LATgJhkPJMgTwKCdFjyPHEnKxFCDhEAACH5BAkKAAAALAAAAAAgACAAAATzEMhJaVKp6s2nIkolIJ2WkBShpkVRWqqQrhLSEu9MZJKK9y1ZrqYK9WiClmvoUaF8gIQSNeF1Er4MNFn4SRSDARWroAIETg1iVwuHjYB1kYc1mwruwXKC9gmsJXliGxc+XiUCby9ydh1sOSdMkpMTBpaXBzsfhoc5l58Gm5yToAaZhaOUqjkDgCWNHAULCwOLaTmzswadEqggQwgHuQsHIoZCHQMMQgQGubVEcxOPFAcMDAYUA85eWARmfSRQCdcMe0zeP1AAygwLlJtPNAAL19DARdPzBOWSm1brJBi45soRAWQAAkrQIykShQ9wVhHCwCQCACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiRMDjI0Fd30/iI2UA5GSS5UDj2l6NoqgOgN4gksEBgYFf0FDqKgHnyZ9OX8HrgYHdHpcHQULXAS2qKpENRg7eAMLC7kTBaixUYFkKAzWAAnLC7FLVxLWDBLKCwaKTULgEwbLA4hJtOkSBNqITT3xEgfLpBtzE/jiuL04RGEBgwWhShRgQExHBAAh+QQJCgAAACwAAAAAIAAgAAAE7xDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfZiCqGk5dTESJeaOAlClzsJsqwiJwiqnFrb2nS9kmIcgEsjQydLiIlHehhpejaIjzh9eomSjZR+ipslWIRLAgMDOR2DOqKogTB9pCUJBagDBXR6XB0EBkIIsaRsGGMMAxoDBgYHTKJiUYEGDAzHC9EACcUGkIgFzgwZ0QsSBcXHiQvOwgDdEwfFs0sDzt4S6BK4xYjkDOzn0unFeBzOBijIm1Dgmg5YFQwsCMjp1oJ8LyIAACH5BAkKAAAALAAAAAAgACAAAATwEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GGl6NoiPOH16iZKNlH6KmyWFOggHhEEvAwwMA0N9GBsEC6amhnVcEwavDAazGwIDaH1ipaYLBUTCGgQDA8NdHz0FpqgTBwsLqAbWAAnIA4FWKdMLGdYGEgraigbT0OITBcg5QwPT4xLrROZL6AuQAPUS7bxLpoWidY0JtxLHKhwwMJBTHgPKdEQAACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GAULDJCRiXo1CpGXDJOUjY+Yip9DhToJA4RBLwMLCwVDfRgbBAaqqoZ1XBMHswsHtxtFaH1iqaoGNgAIxRpbFAgfPQSqpbgGBqUD1wBXeCYp1AYZ19JJOYgH1KwA4UBvQwXUBxPqVD9L3sbp2BNk2xvvFPJd+MFCN6HAAIKgNggY0KtEBAAh+QQJCgAAACwAAAAAIAAgAAAE6BDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfYIDMaAFdTESJeaEDAIMxYFqrOUaNW4E4ObYcCXaiBVEgULe0NJaxxtYksjh2NLkZISgDgJhHthkpU4mW6blRiYmZOlh4JWkDqILwUGBnE6TYEbCgevr0N1gH4At7gHiRpFaLNrrq8HNgAJA70AWxQIH1+vsYMDAzZQPC9VCNkDWUhGkuE5PxJNwiUK4UfLzOlD4WvzAHaoG9nxPi5d+jYUqfAhhykOFwJWiAAAIfkECQoAAAAsAAAAACAAIAAABPAQyElpUqnqzaciSoVkXVUMFaFSwlpOCcMYlErAavhOMnNLNo8KsZsMZItJEIDIFSkLGQoQTNhIsFehRww2CQLKF0tYGKYSg+ygsZIuNqJksKgbfgIGepNo2cIUB3V1B3IvNiBYNQaDSTtfhhx0CwVPI0UJe0+bm4g5VgcGoqOcnjmjqDSdnhgEoamcsZuXO1aWQy8KAwOAuTYYGwi7w5h+Kr0SJ8MFihpNbx+4Erq7BYBuzsdiH1jCAzoSfl0rVirNbRXlBBlLX+BP0XJLAPGzTkAuAOqb0WT5AH7OcdCm5B8TgRwSRKIHQtaLCwg1RAAAOwAAAAAAAAAAAA=='
                        pdfWindow.document.write('<head><title>Rechnung - Aktuell - ' + memberID + '</title></head><div id="load"><img src="' + loade + '"/> &nbsp; lade Rechnung</div>')
                        let data = await getProforma(memberID)
                        pdfWindow.document.write(
                            "<iframe width='100%' height='100%' src='data:application/pdf;base64," + encodeURI(data) + "'></iframe>"
                        )
                        pdfWindow.document.getElementById("load").innerHTML = "";
                    } else {
                        alert ("Bitte Kunden auswaehlen")
                    }
                }
            },
            View(item) {
                return item ? item:'-Rechnungs eMail-'
            },
            async ChangeRechnungMail(item) {
                //console.log('Change RNMail' + JSON.stringify(item))
                if (item) {
                    //console.log(item.memberProperties.rechnungseMail)
                    if (item.memberProperties.rechnungseMail) {
                        this.RMEdit = await PushRechnungseMail(item.memberID, item.memberProperties.rechnungseMail)
                    }
                }
                this.RMEdit=false
            },
            showGruppe() {
                var mp = this.data.memberProperties
                if (mp && mp.gpn) {
                    if (mp.gpn.startsWith('0001')) {
                        return '0001'
                    } else if (mp.gpn.startsWith('0002')) {
                        return '0002'
                    }
                }
                return "0000";
            }
        },
        created() {
            
        },
        watch: {
            data: function () {
                //console.log('Trigger new Search' + JSON.stringify(v))
                this.initState()
            }
        }
    };
</script>

<style scoped>
    .viewbox{
        padding: 0.5em;
        border: 1px solid gray;
        border-radius: 5px;
    }

    .bankblock {
        background-color: aliceblue;
        padding: 8px 8px 8px 8px;
        margin: 2px 2px 2px 0px;
        border: solid 1px lightgray;
        border-radius: 8px;
        min-width: 750px;
    }

    .p1{
        padding-left:1em;
        padding-right:1em;
    }

    .adressblock {
        background-color: aliceblue;
        padding: 8px 8px 8px 8px;
        margin: 2px 2px 2px 0px;
        border: solid 1px lightgray;
        border-radius: 8px;
    }
    .posleft{
        float:left;
        width: calc(100vh -100px);
    }

    .posright{
        float: right;
    }

    .h2em{
        height: 2em !important;
    }
</style>